// extracted by mini-css-extract-plugin
export var base = "_2x-0";
export var updateBanner = "_2x-1";